/** [rfq.requested-terms](../../../docs/product/rfqs.md#rfq-requested-terms): requested schedules and prices are posting preferences, with no payment state. */
export type RfqDesiredMilestone = { label: string; percentage: number };
export type RfqDesiredMilestoneDraft = { label: string; percentage: string };
export const MAX_RFQ_DESIRED_MILESTONES = 8;
export const MAX_RFQ_DESIRED_PRICE = 100_000_000;

/** Next and Publish share draft feedback; the posting API remains the validation authority. */
export function desiredMilestonesError(stages: RfqDesiredMilestoneDraft[]): string | null {
  if (!stages.length || stages.length > MAX_RFQ_DESIRED_MILESTONES) return "Add between one and eight desired milestones.";
  if (stages.some(stage => stage.label.trim().length < 2 || stage.label.trim().length > 120)) return "Give each desired milestone a deliverable.";
  if (stages.some(stage => !/^\d+(?:\.\d{1,2})?$/.test(stage.percentage.trim()) || Number(stage.percentage) <= 0 || Number(stage.percentage) > 100)) {
    return "Enter a desired milestone percentage from 0.01 to 100 with up to two decimal places.";
  }
  // Compare hundredths so decimal percentages do not accumulate binary rounding errors.
  const total = stages.reduce((sum, stage) => sum + Math.round(Number(stage.percentage) * 100), 0);
  return total === 10_000 ? null : "Desired milestone percentages must total 100%.";
}

export function desiredPriceError(price: string): string | null {
  if (!price.trim()) return null;
  const amount = Number(price);
  if (!/^\d+(?:\.\d{1,2})?$/.test(price.trim()) || !Number.isFinite(amount) || amount <= 0) return "Enter a positive desired price with up to two decimal places.";
  return amount <= MAX_RFQ_DESIRED_PRICE ? null : "Desired price must not exceed ₱100,000,000.";
}
